import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import Footer from "./FooterComponent";
import { AuthContext } from "./AuthContextComponent";
import { useUserLogin } from "../hooks";
import { useAppContext } from "./VersionContext";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const { beversion } = useAppContext();

  const shouldShowFooter =
    location.pathname === "/paymentsolution/manual-upload" ||
    location.pathname === "/paymentsolution/reports" ||
    location.pathname === "/paymentsolution/track" ||
    location.pathname === "/paymentsolution/approve" ||
    location.pathname === "/paymentsolution/patchnote" ||
    location.pathname === "/paymentsolution/profile" ||
    location.pathname === "/paymentsolution/profile/about" ||
    location.pathname === "/paymentsolution/profile/change-password" ||
    location.pathname === "/paymentsolution/profile/theme" ||
    location.pathname === "/paymentsolution/profile/secret-question" ||
    location.pathname === "/paymentsolution/reprocess" ||
    location.pathname === "/paymentsolution/inbox-notification";

  const { userInfo } = useContext(AuthContext);
  const backgroundColor = userInfo?.theme === "DARK" ? "#2b3137" : "#EEEEEE";
  return (
    <div
      className="flex flex-col h-screen transition-colors duration-700 ease-in-out"
      style={{
        fontFamily: "Poppins",
        backgroundColor,
      }}
    >
      <main
        className={`flex-grow flex flex-col min-h-0 overflow-x-hidden ${
          shouldShowFooter ? "pb-[40px]" : ""
        } ${
          location.pathname !== "/paymentsolution/inbox-notification"
            ? "overflow-y-auto"
            : "overflow-y-hidden"
        }`}
      >
        {children}
      </main>
      {shouldShowFooter && <Footer beversion={beversion || ""} />}
    </div>
  );
};

export default Layout;
